<template>
	<div>
		<el-dialog :visible.sync="look" width="1000px">
			<div class="annotation1">
				<span>温馨提示：当鼠标放在图上将停止播放</span>
			</div>
			<el-carousel indicator-position="none" :interval="1000" height="570px">
				<div v-for="(items,keys) in imageData" :key="keys">
					<el-carousel-item v-for="(item,key) in items.data" :key="key" v-if="typeof item=='object'">
						<el-image style="width: 100%;" :src="config.apiurl + item.image"></el-image>
					</el-carousel-item>
				</div>
			</el-carousel>
		</el-dialog>
		<el-row>
			<el-col :span="24">
				<div class="bread">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item v-if="$store.state.main.user.m_qaedas_id==0" :to="{ path: '/main' }">基地管理</el-breadcrumb-item>
						<el-breadcrumb-item>定时抓图</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<div class="annotation">
					<span>温馨提示：当前每天抓图时间为早上8:00、中午12:00、下午6:00</span>
					<span class="look" @click="look=true">查看全部</span>
				</div>
			</el-col>
			<el-col :md="9">
				<el-table :max-height="($store.state.height - 173)+''" ref="singleTable" :data="imageData" highlight-current-row @current-change="tableRowClick" style="width: 100%; margin-top: 15px;">
					<el-table-column type="index" width="50"></el-table-column>
					<el-table-column prop="date" label="时间">
						<template slot-scope="scope">
							{{ Totime(scope.row.date).split(' ')[0] }}
						</template>
					</el-table-column>
					<el-table-column prop="type" label="抓图方式"></el-table-column>
					<el-table-column prop="count" label="图片数量"></el-table-column>
				</el-table>
			</el-col>
			<el-col :md="15" class="image-div" :style="'height: ' + ($store.state.height - 173) + 'px;'">
				<div v-for="item in imageDay" class="image-card" :key="item.id">
					<div v-if="typeof item=='object'">
						<el-image class="images" :src="config.apiurl + item.image" :preview-src-list="[config.apiurl + item.image]"></el-image>
						<div class="card-title">{{ item.videoName }}<!-- (<span class="vcr">{{ item.vcrName }}</span>) --></div>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				look: false,
				imageData: [],
				imageDay: []
			};
		},
		methods: {
			load()
			{
				this.api.Screenshot.getList( { order: "createTime desc",limitCount: 1000 } )
				.then((res)=>{
					let keys = 0;
					for(let key in res.data.data.list)
					{
						if(Number(key) > Number(keys))
						{
							keys = key;
						}
						this.imageData.unshift({
							date: key,
							count: res.data.data.list[key].count,
							type: res.data.data.list[key].type,
							data: res.data.data.list[key]
						})
					}
					this.imageDay=res.data.data.list[keys];
					for(let i=0;i<this.imageData.length;i++)
					{
						if(this.imageData[i].date==keys)
						{
							this.$refs.singleTable.setCurrentRow(this.imageData[i]);
							break;
						}
					}
				})
			},
			tableRowClick(val)
			{
				this.imageDay = val.data;
			}
		},
		mounted: function () {
			this.load();
		},
		watch: {
			
		}
	}
</script>

<style scoped>
	.bread{
		height: 14px;
		padding: 8px 0;
	}
	.image-div{
		margin-top: 5px;
		overflow-y: auto;
		overflow-x: hidden;
	}
	.image-card{
		float: left;
		width: 330px;
		margin-bottom: 10px;
	}
	.images{
		height: 200px;
		width: 320px;
		margin: 10px;
		margin-bottom: 0;
		border-radius: 5px;
	}
	.card-title{
		text-align: center;
	}
	.vcr{
		font-size: 14px;
	}
	.annotation{
		font-size: 14px;
		color: red;
		margin-top: 10px;
	}
	.annotation1{
		font-size: 14px;
		color: red;
		margin-bottom: 10px;
	}
	.look{
		float: right;
		color: #409eff;
		font-size: 16px;
		cursor: pointer;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.image-div{
			height: auto !important;
		}
		.image-card{
			width: 100%;
		}
		.images{
			width: 96%;
			margin: 2%;
		}
		.annotation{
			font-size: 12px;
		}
		.look{
			display: none;
		}
	}
</style>
